import gsap from "gsap";
import {
  getHotspotNavigation,
  getSiblingHotspotConfig,
} from "../hotspots/config.js";

export function createExperienceController({
  configs,
  camera,
  hotspots,
  legend,
  infocards,
}) {
  let activeKey = null;

  function activate(key) {
    const hotspot = hotspots.getByKey(key);
    if (!hotspot || !camera.isReady()) return;

    if (!hotspot.cameraPosition || !hotspot.cameraTarget) {
      console.error(
        `[Hotspots] Cannot focus camera for '${key}'. Missing camera_${key} or cameraTarget_${key} in GLTF scene.`,
      );
      return;
    }

    const pose = camera.getPose(
      hotspot.cameraPosition,
      hotspot.cameraTarget,
    );
    const navigation = getHotspotNavigation(configs, key);
    if (!pose || !navigation) return;

    activeKey = key;
    legend.setActive(key);
    legend.setCollapsed(true);
    infocards.setNavigation(navigation);

    gsap.killTweensOf([
      ...camera.getAnimationTargets(),
      ...infocards.getAnimationTargets(),
    ]);
    infocards.hideAll();

    const timeline = camera.createTimeline();
    camera.appendFocus(timeline, pose);
    infocards.appendShow(timeline, hotspot.cardName, hotspot.element);
  }

  function navigate(direction) {
    const sibling = getSiblingHotspotConfig(configs, activeKey, direction);
    if (sibling) activate(sibling.key);
  }

  function reset() {
    if (!camera.isReady()) return;

    const activeCard = infocards.takeActiveCard();
    if (!activeCard) return;

    activeKey = null;
    legend.setActive();
    legend.setCollapsed(false);

    gsap.killTweensOf([
      ...camera.getAnimationTargets(),
      activeCard,
      ...infocards.getAnimationTargets(),
    ]);

    const timeline = camera.createTimeline();
    infocards.appendHide(timeline, activeCard);
    camera.appendReset(timeline);
  }

  return {
    activate,
    navigate,
    reset,
    getActiveKey: () => activeKey,
    destroy() {
      gsap.killTweensOf([
        ...camera.getAnimationTargets(),
        ...infocards.getAnimationTargets(),
      ]);
      activeKey = null;
    },
  };
}
